<script setup lang="ts">
import { computed, ref } from "vue";
import { ElMessage } from "element-plus";
import { Close, Promotion } from "@element-plus/icons-vue";
import { api, jsonBody } from "../api";

const props = defineProps<{ from: string; reply?: { subject?: string; sender?: Array<string | { address?: string }> } | null }>();
const emit = defineEmits<{ close: []; sent: [] }>();
const recipient = ref(props.reply ? (typeof props.reply.sender?.[0] === "string" ? props.reply.sender[0] : props.reply.sender?.[0]?.address ?? "") : "");
const subject = ref(props.reply?.subject ? `Re: ${props.reply.subject}` : "");
const text = ref("");
const sending = ref(false);
const canSend = computed(() => recipient.value.includes("@") && (subject.value.trim() || text.value.trim()));

async function send() {
  if (!canSend.value) return;
  sending.value = true;
  try {
    await api("/api/v1/mail/send", { method: "POST", headers: { "idempotency-key": crypto.randomUUID() }, ...jsonBody({ from: props.from, to: recipient.value.split(",").map((value) => value.trim()).filter(Boolean), cc: [], bcc: [], subject: subject.value, text: text.value }) });
    ElMessage.success("邮件已提交发送"); emit("sent");
  } catch (error) { ElMessage.error(error instanceof Error ? error.message : "发送失败"); }
  finally { sending.value = false; }
}
</script>

<template>
  <div class="compose-drawer">
    <div class="compose-header"><div><span class="eyebrow">NEW LETTER</span><h2>写邮件</h2></div><button class="icon-button" @click="emit('close')"><Close /></button></div>
    <div class="compose-fields"><label><span>发件人</span><input :value="from" disabled /></label><label><span>收件人</span><input v-model="recipient" type="text" inputmode="email" autofocus placeholder="name@example.com，多个地址用逗号分隔" /></label><label><span>主题</span><input v-model="subject" placeholder="写一个清晰的主题" /></label></div>
    <textarea v-model="text" class="compose-body" placeholder="开始写信…" />
    <div class="compose-footer"><small>Cloudflare 原生发送 · Resend 自动回退</small><button class="primary-button" :disabled="!canSend || sending" @click="send"><Promotion /> {{ sending ? '发送中…' : '发送' }}</button></div>
  </div>
</template>
